import React from "react";
import Navbar from "./global-components/navbar-v2";
import PageHeader from "./global-components/page-header";
import Service from "./section-components/service-v5";
import Cta from "./section-components/cta-v10";
import FaqV2 from "./section-components/faq-v2";
import Testimonial from "./section-components/testimonial-v2";
import Brand from "./section-components/brand-v4";
import Case from "./section-components/case";
import Footer from "./global-components/footer-v2";

const ServiceV1 = () => {
  let ServiceObject = {
    serviceHeading:
      "Engage and Retain Your Target Audience with Valuable and Relevant Content. Build a strong online presence, attract your audience, and increase brand visibility. Position yourself as an industry leader, drive organic website traffic, nurture leads, and develop client relationships through informative and optimized content. Maximize your strategy with measurable performance and tailored content marketing strategies aligned with your company objectives.",
    servicePointsLoop: [
      "Attract and retain target audience with valuable content.",
      "Build a strong online presence and increase brand visibility.",
      "Position yourself as an industry leader through informative content.",
      "Drive conversions, engage leads, and nurture client relationships.",
    ],
    serviceDiv: [
      {
        heading: "Content Creation and Distribution",
        description: "Create and distribute valuable and engaging content to attract and engage your target audience effectively.",
      },
      {
        heading: "Brand Building and Online Presence",
        description:
          "Build a strong online presence and increase brand visibility through strategic content marketing efforts.",
      },
      {
        heading: "Thought Leadership and Reputation Management",
        description: "Establish yourself as a thought leader in your industry and manage your online reputation through informative and authoritative content.",
      },
      {
        heading: "Conversion Optimization and Lead Nurturing",
        description:
          "Optimize content for conversions, engage leads, and nurture customer relationships throughout their buyer's journey.",
      },
    ],
  };
  let workWithUs =
    "Work with us to harness the power of content marketing and elevate your brand. Our tailored strategies will attract and engage your target audience, build your online presence, and drive conversions, helping you achieve your business objectives.";

  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Content Marketing" />
      <Service serviceDetail={ServiceObject} />
      <Cta workWithUs={workWithUs} />
      <FaqV2 />
      <Testimonial />
      <Brand />
      <Case customclass="case-one case-one__team-page case-one__service-page" />
      <Footer />
    </div>
  );
};

export default ServiceV1;
